import DeleteGenericModal from "../../modals/DeleteGenericModal";
import ReactTable from "../../util/ReactTable";
import AsyncBlock from "../../components/forms/AsyncBlock";
import PageTitle from "../../components/layout/PageTitle";
import PageSection from "../../components/layout/PageSection";
import Button from "../../components/forms/Button";
import PageContainerFull from "../../components/layout/PageContainerFull";
import {useCallback, useMemo} from "react";
import {FlexLayout} from "../../components/flex/Flex";
import useDeleteModal from "../../modals/useDeleteModal";
import axios from "axios";
import useFetch2 from "../../hooks/useFetch2";
import {Apis} from "../../util/data";
import {useNavigate} from "react-router-dom";
import * as React from "react";
import useEditModal from "../../modals/useEditModal";
import UploadConsejeria from "../../components/UploadConsejeria";
import UploadProducto from "../../components/UploadProducto";
import GenericModal2 from "../../modals/GenericModal2";

const ProductoList = () => {

  const navigate = useNavigate()
  const {loading, data, fetchData, error} = useFetch2(Apis.PROD + '/producto/list', []);

  const deleteElement = id => axios.delete(Apis.PROD + '/producto/' + id)

  const {
    wrapper: wrapper1,
    openDeleteModal
  } = useDeleteModal({
    text: '¿Desea eliminar este producto?',
    action: deleteElement,
    onRefresh: fetchData
  })

  const {wrapper: wrapper2, editAction} = useEditModal({
    editComponent: <UploadProducto />,
    onRefresh: fetchData
  });

  function addProductos() {
    navigate('/productos/new')
  }

  function editProductos(item) {
    navigate('/productos/edit/' + item.id)
  }

  const actionsValue = useCallback(cell =>
      <FlexLayout justifyContent='center'>
        <Button size='xs' variant='light' onClick={() => editProductos(cell.row.original)}>Editar</Button>
        <Button size='xs' variant='danger' onClick={() => openDeleteModal(cell.row.original.id)}>Eliminar</Button>
        <Button size='xs' variant='light' onClick={() => editAction({id: cell.row.original.id, url: cell.row.original.url})}>Foto</Button>
      </FlexLayout>
    // eslint-disable-next-line react-hooks/exhaustive-deps
    , []);

  const columns = useMemo(
    () => [
      {
        header: 'Categoria',
        accessorKey: 'categoria'
      },
      {
        header: 'Codigo',
        accessorKey: 'codigo'
      },
      {
        header: 'Nombre',
        accessorKey: 'nombre'
      },
      {
        header: 'Presentacion',
        accessorKey: 'presentacion'
      },
      {
        header: 'Beneficios',
        accessorKey: 'beneficios'
      },
      {
        header: 'Modo de uso',
        accessorKey: 'modoUso'
      },
      {
        header: 'Advertencias',
        accessorKey: 'advertencias'
      },
      {
        header: 'Precio lista',
        accessorKey: 'precioLista',
        meta: {
          headerClassName: 'text-center', // class para la cabecera
          columnClassName: 'text-center', // class para la columna
        },
      },
      {
        header: 'Descuento (%)',
        accessorKey: 'porcDesc',
        meta: {
          headerClassName: 'text-center', // class para la cabecera
          columnClassName: 'text-center', // class para la columna
        },
      },
      {
        header: 'Precio',
        accessorKey: 'precio',
        meta: {
          headerClassName: 'text-center', // class para la cabecera
          columnClassName: 'text-center', // class para la columna
        },
      },
      {
        header: 'Extension',
        accessorKey: 'extension'
      },
      {
        header: 'Stock',
        accessorKey: 'stock'
      },
      {
        header: 'Acciones',
        accessorKey: 'id',
        meta: {
          headerClassName: 'text-center', // class para la cabecera
          columnClassName: 'text-center', // class para la columna
        },
        enableSorting: false, // para deshabilitar el sort
        cell: actionsValue
      }
    ]
    // eslint-disable-next-line react-hooks/exhaustive-deps
    , [data]
  )

  return (
    <PageContainerFull>

      <PageSection>
        <PageTitle title={'Productos'}/>

        <AsyncBlock loading={loading} error={error}>
          <ReactTable
            columns={columns}
            data={data || []}
            customSearch
            filterAdd={() => addProductos()}
            noData='No existen productos'
            pageSize={20}
          />
        </AsyncBlock>
      </PageSection>
      <DeleteGenericModal {...wrapper1} />
      <GenericModal2 {...wrapper2} />
    </PageContainerFull>
  )
}

export default ProductoList
